import {getPrivateAxios} from '../../libs';
import {GuideStep} from './types';

type GuideStepCreateDto = Pick<GuideStep, 'payload' | 'position'>;

export const fetchGuideStepCreate = async (guideId: string, createDto: GuideStepCreateDto) => {
  return getPrivateAxios()
    .post<void>(`/guides/${guideId}/steps`, createDto)
    .then((r) => r.data);
};
